module.exports = __webpack_public_path__ + "img/vue.40e2bc35.png";